// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__1GMy2","header":"MessagesList_header__1f4fH","chat":"MessagesList_chat__2jCZA"};